module.exports = __webpack_public_path__ + "static/media/P1_NORM.f87a392f.png";